export default {
  receipt: `
  <html>
  <head>
    <style>
      * {
        box-sizing: border-box;
      }
      html,
      body {
        width: 1080px;
        padding: 0;
        margin: 0;
      }
      .body {
        position: relative;
        padding: 16px;
        margin: 16px;
        border: 1px solid #000;
        color: #000;
      }
      .body img.is-invalid {
        position: absolute;
        left: 0;
        top: 16px;
        left:580px;        
        width: 80px;
        height: 80px;        
        z-index: 0;
      }
      .body .title {
        margin: 0;
        text-align: center;
        font-size: 16px;
        font-weight: 600;
      }
      .body > p {
        margin: 12px 0;
        font-size: 12px;
        color: #000;
        white-space: nowrap;
      }
      .body > p.strong {
        font-weight: 600;
      }
      .body table {
        margin-bottom: 44px;
        width: 100%;
        border-collapse: collapse;
        border-color: #000;
        font-size: 14px;
      }
      .body table td,
      .body table th {
        padding: 0 8px;
        height: 30px;
        text-align: left;
        border-width: 0 0 1px 0;
      }
      .body table td:last-child,
      .body table th:last-child {
        text-align: right;
      }
      .body table th {
        font-weight: 400;
        white-space: nowrap;
      }
      .body table tr.last-line > td {
        height: auto;
      }
      .body table tr:last-child > td {
        text-align: left;
      }
      .body table .footer-td-div {
        display: flex;
      }
      .body table .footer-td-div > div {
        display: flex;
        height: 30px;
        align-items: center;
      }
      .body table .footer-td-div > div:not(:first-child) {
        padding: 0 8px;
        flex: 1;
      }
      .body table .footer-td-div > div:first-child {
        margin-right: 32px;
      }
      .body table .footer-td-div > div.pay-fact {
        flex: 1;
      }
      .body table .footer-td-div > div.pay-fact:first-child {
        margin-right: 0px;
      }
      .body table .footer-td-div > div:last-child {
        padding-right: 0;
        justify-content: flex-end;
      }
      .body table .footer-td-div > div.prestore {
        margin: 0;
        flex: 1;
      }
    </style>
  </head>
  <body>
    <div class="body">
      {{if orderInfosObj.orderStatus === 4}}
        <img class="is-invalid" src="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/teacher/0048.png"/>
      {{/if}}
      <p class="title">
        {{ userInfo.companyInfoVo.companyName }}收据
      </p>
      <p class="strong">
        <span>收据编号：</span>
        <span>{{ paymentObj.groupNo }}</span>
      </p>
      <p>
        <span class="lable-name">学员姓名：</span>
        <span>{{ orderInfosObj.studentName }}</span>&emsp;
        <span class="lable-name">经办老师：</span>
        <span>{{ paymentObj.handleTeacherName }}</span>&emsp;
        <span class="lable-name">经办日期：</span>
        <span>
          {{ paymentObj.createTime | formatDatetime 'yyyy-MM-dd' }}
        </span>
      </p>
      <table border="1">
        <tr>
          <th>购买项目</th>
          <th>售价</th>
          <th>购买数量</th>
          <th>赠送数量</th>
          <th>直减/折扣</th>
          <th style="text-align:center;">有效期</th>
          <th>项目金额</th>
        </tr>
        {{set orderItems = orderInfosObj.orderItems || []}}
        {{each orderItems}}
        <tr>
          <td>
            {{if $value.commodityType == 0}}
              <div>{{ $value.productName | getGoodsShowName $value.priceItemDetail.commodityPriceType $value.priceItemDetail.priceName}}</div>
            {{else if $value.commodityType == 1}}    
              <div>{{ $value.productName }}</div>
              <div style="color: #000">
                [{{ $value.curriculumName || '-' }}]&nbsp;{{ $value.priceItemName }}
              </div>
            {{else if $value.commodityType == 2}}
              <div>[{{ $value.curriculumName }}]{{ $value.priceItemName }}</div>
            {{/if}}
        </td>

          <!--费用预存无购买课时和单价-->
          {{if orderInfosObj.sourceType !== 7}}
            <td>
              {{if $value.commodityType === 0}}
                <div>￥{{$value.priceItemDetail.price | formatNumber}}/{{$value.priceItemDetail.priceUnitName}}</div>
              {{else}}
              <div>
                  ￥{{ $value.priceItemDetail.price | formatNumber }} (包含{{
                    $value.priceItemDetail.priceNum
                  }}课时)
                </div>
                {{if !$value.priceItemDetail.originalPrice}}
                  <div style="color: #000">
                    {{ $value.priceItemDetail.priceName }}
                  </div>
                {{/if}}
              {{/if}}
            </td>
            <td>
              {{ $value.productQuantity }}
            </td>
            <td>
              {{if ($value.commodityType === 1 ||  $value.commodityType === 2) && $value.freeAmount > 0}}
                <span>
                  {{ $value.freeAmount }}{{ $value.priceItemDetail.priceUnitName }}
                </span>
              {{/if}}
            </td>
            <td>
              {{if $value.discountMoney > 0}}
                <span style="white-space: nowrap;">
                  <span> -￥{{ $value.discountMoney | formatNumber}} </span>
                  {{if $value.discount !== null && $value.discount !== '' && $value.discount >= 0}}
                    <span>
                      ({{ $value.discount }}折)
                    </span>
                  {{/if}}
                </span>
              {{/if}}
            </td>
            <td style="text-align:center;">
              {{if $value.chargeType == 2 }}
                {{ $value.feeExpireStartTime | formatDatetime 'yyyy-MM-dd'}} 至 {{ $value.feeExpireTime | formatDatetime 'yyyy-MM-dd'}}
              {{else if $value.chargeType == 1 && $value.feeExpireTime}}
                截至{{ $value.feeExpireTime | formatDatetime 'yyyy-MM-dd' }}
              {{/if}}
            </td>
          {{else}}
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
            <td>--</td>
          {{/if}}
          <td style="text-align:right;">￥{{ $value.orderItemReceivableMoney | formatNumber}}</td>
        </tr>
        {{/each}}
        <tr>
          <td colspan="7" style="text-align:right;">
            订单金额：￥{{ orderInfosObj.orderReceivableMoney | formatNumber }}
          </td>
        </tr>
        <tr class="last-line">
          {{ if paymentObj.paymentRecordList.length < 3}}
            {{each paymentObj.paymentRecordList}}
              <td colspan="2">
                {{ $value.payMethodDesc }}：￥{{ ($value.money || 0) | formatNumber }}
              </td>
            {{/each}}
            <td colspan="5" style="text-align: right">
              实付金额：￥{{ paymentObj.money | formatNumber }}
            </td>
          {{/if}}
        </tr>
        {{if paymentObj.afterOweMoney > 0}}
          <tr >
            <td colspan="7" style="text-align: right">
              欠交总额：￥{{ paymentObj.afterOweMoney | formatNumber }}
            </td>
          </tr>
        {{/if}}

        {{set transferInOrderRelationDtos = orderInfosObj.transferInOrderRelationDtos || []}}
        {{each transferInOrderRelationDtos}}
        <tr>
          <td colspan="7">
            备注：{{ $value.transferOutName }}转入￥{{ $value.transferMoney |  formatNumber }}
          </td>
        </tr>
        {{/each}}
      </table>
    </div>
  </body>
</html>


`,
};
